import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  initialState,
  USER_FEATURE_KEY,
  UserState,
  userAdapter,
} from './user.reducer'

export const selectUserState =
  createFeatureSelector<UserState>(USER_FEATURE_KEY)

const { selectAll, selectEntities } = userAdapter.getSelectors()

const selectSafeUserState = createSelector(selectUserState, (state: UserState) => ({
  ...initialState,
  ...state,
  ids: state?.ids ?? initialState.ids,
  entities: state?.entities ?? initialState.entities,
  currentUser: state?.currentUser ?? null,
  totalCount: state?.totalCount ?? 0,
  loading: state?.loading ?? false,
  error: state?.error ?? null,
}))

export const selectUsers = createSelector(selectSafeUserState, (state) =>
  selectAll(state)
)

export const selectUsersEntities = createSelector(
  selectSafeUserState,
  (state) => selectEntities(state)
)

export const selectTotalCount = createSelector(
  selectSafeUserState,
  (state) => state.totalCount
)

export const selectUsersLoading = createSelector(
  selectSafeUserState,
  (state) => state.loading
)

export const selectUsersError = createSelector(
  selectSafeUserState,
  (state) => state.error
)

export const selectUserCreateError = createSelector(
  selectSafeUserState,
  (state) => state.error
)

export const selectCurrentUser = createSelector(
  selectSafeUserState,
  (state) => state.currentUser
)

export const selectUserLoading = createSelector(
  selectSafeUserState,
  (state) => state.loading
)

export const selectUserError = createSelector(
  selectSafeUserState,
  (state) => state.error
)
